var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOrders({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 16,
    viewBox: "0 0 14 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.85707 2.28575H11.2856C11.6645 2.28575 12.0279 2.43626 12.2958 2.70417C12.5637 2.97208 12.7142 3.33544 12.7142 3.71432V13.7143C12.7142 14.0932 12.5637 14.4566 12.2958 14.7245C12.0279 14.9924 11.6645 15.1429 11.2856 15.1429H2.71422C2.33534 15.1429 1.97197 14.9924 1.70406 14.7245C1.43615 14.4566 1.28564 14.0932 1.28564 13.7143V3.71432C1.28564 3.33544 1.43615 2.97208 1.70406 2.70417C1.97197 2.43626 2.33534 2.28575 2.71422 2.28575H4.14279M4.85707 0.857178H9.14279C9.53728 0.857178 9.85707 1.17697 9.85707 1.57146V3.00003C9.85707 3.39452 9.53728 3.71432 9.14279 3.71432H4.85707C4.46258 3.71432 4.14279 3.39452 4.14279 3.00003V1.57146C4.14279 1.17697 4.46258 0.857178 4.85707 0.857178Z",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrders);
export default __webpack_public_path__ + "static/media/Orders.f671f84ca532f94ebf85c6ca56ba87c2.svg";
export { ForwardRef as ReactComponent };